import React from 'react';
import { certifications } from '../data/mock';

const Certifications = ({ compact = false }) => {
  return (
    <section
      id="certifications"
      className={`relative bg-white overflow-hidden ${compact ? 'py-16' : 'py-24'}`}
    >
      {/* Subtle dotted pattern */}
      <div
        className="absolute top-6 right-6 w-40 h-40 opacity-40 pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle, rgba(11, 59, 140, 0.25) 1px, transparent 1px)',
          backgroundSize: '14px 14px',
        }}
      />
      <div
        className="absolute bottom-6 left-6 w-40 h-40 opacity-40 pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle, rgba(11, 59, 140, 0.2) 1px, transparent 1px)',
          backgroundSize: '14px 14px',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <div className="text-[#0b3b8c] text-[12px] md:text-[13px] tracking-[0.35em] font-bold">
            GPE ÉNERGIES &amp; SERVICES
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-black text-[#0b1c3a] tracking-tight">
            Nos <span className="text-[#0b3b8c]">certifications</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {certifications.map((c) => (
            <div
              key={c.name}
              className="group relative bg-white rounded-2xl border border-slate-100 shadow-[0_10px_40px_-15px_rgba(15,23,42,0.15)] hover:shadow-[0_18px_50px_-15px_rgba(11,59,140,0.35)] hover:-translate-y-1 transition-all duration-300 pt-10 pb-8 px-6 flex items-center justify-center overflow-hidden"
            >
              <img
                src={c.logo}
                alt={c.name}
                loading="lazy"
                className="max-h-24 md:max-h-28 w-auto object-contain"
              />

              {/* Bottom blue underline */}
              <span className="absolute left-6 right-6 bottom-3 h-[3px] rounded-full bg-[#0b3b8c] transition-all" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
